import React from 'react';
import { Link } from 'react-router-dom';
import { buildWhatsAppUrl, WHATSAPP_DISPLAY } from '../constants/contact';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0a66c2] text-white mt-auto">
      <div
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="bg-[#004182] hover:bg-[#003d75] text-center py-4 cursor-pointer transition-colors"
      >
        <span className="text-sm">Back to top</span>
      </div>

      <div className="bg-[#004182] py-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="font-bold mb-3">Get to Know Us</h3>
              <ul className="space-y-2 text-sm text-gray-200">
                <li>
                  <Link to="/" className="hover:underline">
                    Careers
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    About Segco Wholesalers
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Investor Relations
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Segco Wholesalers catalog
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3">Make Money with Us</h3>
              <ul className="space-y-2 text-sm text-gray-200">
                <li>
                  <Link to="/" className="hover:underline">
                    Sell products on Segco Wholesalers
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Sell on Segco Wholesalers Business
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Partner with Segco Wholesalers
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Become an Affiliate
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Advertise Your Products
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3">Segco Wholesalers payment options</h3>
              <ul className="space-y-2 text-sm text-gray-200">
                <li>
                  <Link to="/" className="hover:underline">
                    Segco Wholesalers trade account
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Shop with Points
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Reload Your Balance
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Payment & invoicing
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3">Need Help?</h3>
              <ul className="space-y-2 text-sm text-gray-200">
                <li>
                  <span className="block text-gray-100 font-medium mb-0.5">Contact us</span>
                  <a href="mailto:segco768@gmail.com" className="hover:underline break-all">
                    segco768@gmail.com
                  </a>
                </li>
                <li>
                  <span className="block text-gray-100 font-medium mb-0.5">WhatsApp orders</span>
                  <a
                    href={buildWhatsAppUrl('Hello Segco Wholesalers, I would like to place an order.')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    {WHATSAPP_DISPLAY}
                  </a>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Safety & quality
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Your Account
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Your Orders
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Shipping Rates & Policies
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Returns & Replacements
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:underline">
                    Help
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#0a66c2] border-t border-[#004182] py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center">
            <div className="mb-4">
              <Link to="/" className="text-xl sm:text-2xl font-bold text-center">
                Segco Wholesalers
              </Link>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-200 mb-4">
              <Link to="/" className="hover:underline">
                Angola
              </Link>
              <Link to="/" className="hover:underline">
                Botswana
              </Link>
              <Link to="/" className="hover:underline">
                Comoros
              </Link>
              <Link to="/" className="hover:underline">
                DRC
              </Link>
              <Link to="/" className="hover:underline">
                Eswatini
              </Link>
              <Link to="/" className="hover:underline">
                Lesotho
              </Link>
              <Link to="/" className="hover:underline">
                Madagascar
              </Link>
              <Link to="/" className="hover:underline">
                Malawi
              </Link>
              <Link to="/" className="hover:underline">
                Mauritius
              </Link>
              <Link to="/" className="hover:underline">
                Mozambique
              </Link>
              <Link to="/" className="hover:underline">
                Namibia
              </Link>
              <Link to="/" className="hover:underline">
                Seychelles
              </Link>
              <Link to="/" className="hover:underline">
                South Africa
              </Link>
              <Link to="/" className="hover:underline">
                Tanzania
              </Link>
              <Link to="/" className="hover:underline">
                Zambia
              </Link>
              <Link to="/" className="hover:underline">
                Zimbabwe
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#0a66c2] border-t border-[#004182] py-4">
        <div className="container mx-auto px-4 text-center text-xs text-gray-200">
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <Link to="/" className="hover:underline">
              Conditions of Use
            </Link>
            <Link to="/" className="hover:underline">
              Privacy Notice
            </Link>
            <Link to="/" className="hover:underline">
              Interest-Based Ads
            </Link>
          </div>
          <div>&copy; 2026 Segco Wholesalers. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
